export default __webpack_public_path__ + "static/media/mujer-senalando_dos.7e8c2cc4.png";